<template>
  <div class="reservation-box">
    <menuBox :step="4"></menuBox>
    <div class="title-box">
      <p>Explore The World</p>
      <span>Contact Us</span>
      <p>If you have travel needs, please contact us</p>
    </div>
    <div class="connectUs">
      <div class="item">
        <img src="../assets/connectTel.png" alt="">
        <p>Call Us</p>
        <span>9149205525</span>
      </div>
      <div class="item">
        <img src="../assets/connectEmail.png" alt="">
        <p>Email Us</p>
        <span>pipetitaniumalloy@gmail.com</span>
      </div>
      <div class="item">
        <img src="../assets/connectAddress.png" alt="">
        <p>Our Office</p>
        <span>HOUSE NO 617/14 SHRI SAMARTH KRUPA, GANESHNAGAR LANE 2, NAVI SANGVI PIMPLE GURAV TAL HAV ELI NA PUNE Pune
          Maharashtra 41106</span>
      </div>
    </div>
    <div class="privacy">
      <div class="title">Travel entrustment service agreement</div>
      <div class="content">
        <div class="bt">1. Acceptance of Agreement</div>
        This Agreement is signed between you (hereinafter referred to as the "Passenger") and HAVYA SYSTEMS LLP
        (hereinafter referred to as the "Company"). By booking any travel product or service, you acknowledge that you
        have read, understood and agree to be bound by the terms and conditions of this Agreement.
      </div>
      <div class="content">
        <div class="bt">2. Service scope</div>
        The company provides services including but not limited to travel arrangement and booking services, travel
        consultation and other services. The specific service content is determined according to the passenger’s booking
        details.
      </div>
      <div class="content">
        <div class="bt">3. Booking and payment</div>
        Passengers should make reservations through the method designated by the company and pay the corresponding service
        fees in accordance with the agreement. All service fees must be paid within the time specified by the company to
        ensure the validity of the reservation.
      </div>
      <div class="content">
        <div class="bt">4. Change and Cancellation Policy</div>
        Passengers may change or cancel their reservation before departure in accordance with the conditions and
        procedures stipulated by the company. Changes or cancellations may incur additional charges, subject to the
        service provider's policies.
      </div>
      <div class="content">
        <div class="bt">5. Travel insurance</div>
        The company strongly recommends that travelers purchase travel insurance to cover losses caused by unforeseen
        events.
      </div>
      <div class="content">
        <div class="bt">6. Limitation of Liability</div>
        The company only provides booking services as an intermediary and does not directly provide any travel products.
        The Company is not responsible for the acts or omissions of service providers or for accidents, delays or other
        problems during the trip.
      </div>
      <div class="content">
        <div class="bt">7. Complaint handling</div>
        For any problems encountered during the journey, passengers should notify the company as soon as possible and the
        company will try its best to help solve it. All complaints should be submitted in writing to the Company within 30
        days of the end of the trip.
      </div>
      <div class="content">
        <div class="bt">8. Applicable law and dispute resolution</div>
        The interpretation and enforcement of this Agreement shall be governed by the laws of India. For any dispute
        arising from this Agreement, both parties shall first seek to resolve it through friendly negotiation. If the
        negotiation fails, either party may file a lawsuit with the court where the company is located.
      </div>
      <div class="content">
        <div class="bt">sign</div>
        This Agreement shall take effect from the date when the passenger confirms and accepts this Agreement when booking
        services.
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "reservation",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
    };
  },
  mounted() { },
  methods: {
  },
};
</script>
<style lang="less" scoped>
.reservation-box {
  .title-box {
    background-image: url(../assets/reservation.png);
    width: 100%;
    height: 700px;
    background-size: 100% 100%;
    overflow: hidden;
    padding: 226px 360px 0;
    box-sizing: border-box;
    text-align: center;

    p {
      font-size: 20px;
      font-family: ArialMT;
      color: #FFFFFF;
    }

    span {
      margin: 8px 0;
      font-size: 72px;
      font-family: Arial, Arial;
      font-weight: 900;
      color: #FFFFFF;
      line-height: 101px;
    }

  }

  .connectUs {
    position: relative;
    top: -60px;
    display: flex;
    padding: 0 330px;

    .item {
      margin-right: 30px;
      width: 33%;
      padding: 24px 30px;
      background: #FFFFFF;
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.13);
      border-radius: 24px;
      text-align: center;

      img {
        margin-bottom: 16px;
        width: 60px;
        height: 60px;
      }

      p {
        margin-bottom: 10px;
        font-size: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #1C1826;
      }

      span {
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #999999;
      }
    }

    .item:nth-child(3) {
      margin-right: 0;
    }
  }

  .privacy {
    margin: 40px 330px 100px;
    padding: 40px;
    background: #F9F9F9;
    border-radius: 24px;
    box-sizing: border-box;

    .title {
      margin-bottom: 15px;
      font-size: 32px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #333333;
      text-align: center;
    }

    .content {
      margin-bottom: 20px;
      font-size: 18px;
      color: #999;
    }

    .bt {
      font-size: 18px;
      color: #333333;
    }
  }
}
</style>
